import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import { useHistory } from 'react-router-dom';
import PremiumOptions from './PremiumOptions';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PremiumOptionsPopup = ({ isOpened }: any) => {

    const history = useHistory();
    return (
        <>
            <div>
                <Dialog
                    className="premiumOptions_modal"
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#faf6f5" } }}
                    fullScreen
                    disableEscapeKeyDown={true}
                    TransitionComponent={Transition}
                    open={isOpened}
                    onClose={history.goBack}
                >
                    <div className='premiumOptions-container' style={{ height: "100%", overflow: "scroll" }}>
                        <PremiumOptions />
                    </div>
                </Dialog>
            </div>
        </>


    )
}


export default PremiumOptionsPopup;